import { css } from 'styled-components'

export const forSmallScreenUp = (inner) => css`
  @media (min-width: 576px) {
    ${inner};
  }
`

export const forMediumScreenUp = (inner) => css`
  @media (min-width: 768px) {
    ${inner};
  }
`

export const forLargeScreenUp = (inner) => css`
  @media (min-width: 992px) {
    ${inner};
  }
`

export const forExtraLargeScreenUp = (inner) => css`
  @media (min-width: 1200px) {
    ${inner};
  }
`
